import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { useHttpClient } from '../../client/HttpClientContext';
import { RESOLVER_DEBOUNCE_KEY, TIME_TOKENS } from '../../utils/timeTokens';
export const useCachedResolver = (referenceType, objectTypeId, options) => {
  const httpClient = useHttpClient();
  return createStandardCachedResolver(referenceType, objectTypeId, Object.assign({}, options, {
    httpClient,
    debouncePeriod: TIME_TOKENS[RESOLVER_DEBOUNCE_KEY]
  }));
};